"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSST001_List = exports.LiveRoomListStyled = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const DSTT001_List_Child_1 = require("../../DST/DSTT001/component/DSTT001_List_Child");
exports.LiveRoomListStyled = styled_components_1.default.div `
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 40px;
	height: 100%;
	overflow: auto;
	.live-class-reservation {
		min-height: auto;
		width: 100%;
		height: 100%;
		gap: 25px;
		flex: 1;
		overflow: hidden;
		min-height: 467px;

		.task-board-container {
			width: 100%;
			display: flex;
			flex-direction: column;
			gap: 40px;
			flex: 1;
			overflow: hidden;
			height: 100%;
		}

		.table {
			width: 100%;
			height: 100%;
			background: #fff;
			padding: 40px;
			border-radius: 23px;
			overflow: hidden;
			flex: 1;
			overflow: hidden;
			height: 100%;
		}
	}
	.live-class-review {
		border-radius: 16px;
		display: flex;
		flex-direction: column;
		gap: 20px;
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
		min-height: 200px;
		width: 100%;
	}
`;
exports.DSST001_List = react_1.default.memo(() => {
    return (react_1.default.createElement(exports.LiveRoomListStyled, null,
        react_1.default.createElement("div", { className: "live-class-reservation" },
            react_1.default.createElement(DSTT001_List_Child_1.ReservationTable, { isTeacher: false, isClosed: false }))));
});
